<template>
    <div>
        <!--------------------------------------radio button----------------------------------------->
        <div class="form-group">
            <div>
                <span class="font-red-sunglo bold">Ajouter une remise ?</span>
                <input type="radio" id="remisenon"  value="remisenon" v-model="reductionpicked" >
                <label for="remisenon">Non</label>
                <input type="radio" id="remiseoui" value="remiseoui" v-model="reductionpicked">
                <label for="remiseoui">Oui</label>
            </div>
        </div>
        <!---------------------------------------End radio button----------------------------------------->

        <!---------------------------------------Select remise ----------------------------------------->

        <div class="row" v-show="reductionpicked == 'remiseoui'">
            <div class="col-md-4">
                <label>Remise (en €)</label>
                <input type="number" ref="input" name="reduction" step="0.01" min="0"
                class="form-control"  v-model="billing.reduction" />
            </div>
        </div>
        <div class="alert alert-info" id="errorMsg" hidden>Vous ne pouvez pas appliquer de remise sur une facture disposant de plusieurs TVA différentes.</div>
    </div>
</template>

<script>
    export default {
        name: "addReductionComponent",
        props: {
            billing: {
                type: Object,
                default: () => {
                    return []
                }
            },
        },
        data () {
            return {
                'reductionpicked' : 'remisenon',
            }
        },
        mounted () {
            if(this.billing.reduction ){
                this.reductionpicked = 'remiseoui'
            }
            let vue = this;
            $("#detail").change(function(){
                let tvas = $.map(JSON.parse($(this).val()), function(o) { if("tva" in o && o['tva']!=""){return o["tva"];} return 0; })
                tvas = tvas.filter(function(item, i, arr) {
                                        return i == arr.indexOf(item);
                                    });
                if(tvas.length>1){
                    $("#remisenon").attr('disabled',true);
                    $("#remiseoui").attr('disabled',true);
                    vue.reductionpicked="remisenon";
                    $("#errorMsg").show()
                }else{
                    $("#remisenon").attr('disabled',false);
                    $("#remiseoui").attr('disabled',false);
                    $("#errorMsg").hide();
                }
            })
        },
        watch: {
            'reductionpicked' : function (newVal, oldVal)//button picked
            {
                if(this.reductionpicked ==  'remisenon' && oldVal!="")
                {
                    this.billing.reduction = null
                }
            }
        }
    }
</script>

<style scoped>

</style>
